export default {
	title: '分析工具配置',
	subtitle: '配置和管理图谱分析工具',
	actions: {
		add: '新增工具',
		edit: '编辑',
		delete: '删除',
		save: '保存',
		cancel: '取消',
		confirm: '确认',
		clear: '清空',
		addNow: '立即新增'
	},
	messages: {
		deleteConfirm: '确认删除该工具吗？',
		deleteSuccess: '删除成功',
		saveSuccess: '保存成功',
		updateSuccess: '更新成功',
		selectDeleteWarning: '请选择要删除的记录',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		nameLengthRange: '配置名称长度应在 1-50 个字符之间',
		atLeastOneTool: '请至少选择一个工具',
		clearedAllSelections: '已清空所有选择',
		confirmClearSelections: '确定要清空所有选择的工具吗？'
	},
	labels: {
		basicInfo: '基本信息',
		name: '名称',
		remark: '描述信息',
		selectedTools: '已选择的工具项',
		availableTools: '可选择的工具项',
		noSelectedTools: '暂无已配置的工具',
		noConfiguredTools: '暂无已配置的工具',
		configName: '配置名称',
		configDescription: '配置描述'
	},
	placeholder: {
		name: '请输入配置名称',
		remark: '请输入配置描述',
		configName: '请输入配置名称'
	},
	status: {
		loading: '正在加载数据...',
		noDataTitle: '暂无工具配置',
		noDataDesc: '您还没有配置任何分析工具，点击上方"新增工具"按钮开始配置',
		saving: '保存中...'
	},
	dialog: {
		editTitle: '编辑工具',
		addTitle: '新增工具',
		deleteConfirmTitle: '删除确认'
	}
}
